/**
 * Owner: Masa Bayu
 * File: demo-cover-assets.ts
 * Date:Time: 2026-09-21 08:50
 * Description: Cover assetRef → static /covers JPEG (UI display) · CDN for packages only.
 */

import { resolveHostCoverUrl } from '../host-catalog/host-cdn-delivery';

/** Raster cover map — UI always prefers these over non-image CDN stubs. */
const COVER_URLS: Readonly<Record<string, string>> = Object.freeze({
  asset_cover_the_creator: '/covers/cover-the-creator.jpg',
  asset_cover_relativity_theory: '/covers/cover-relativity-theory.jpg',
  asset_cover_why_islam: '/covers/cover-why-islam.jpg',
  asset_cover_energy: '/covers/cover-energy.jpg',
  asset_cover_faktor_tenaga: '/covers/cover-faktor-tenaga.jpg',
  asset_cover_faktor_unsur: '/covers/cover-faktor-unsur.jpg',
  // RB-03 production SoT refs → same rasters
  asset_cover_prod_creator: '/covers/cover-the-creator.jpg',
  asset_cover_prod_relativity: '/covers/cover-relativity-theory.jpg',
  asset_cover_prod_energy: '/covers/cover-energy.jpg',
  asset_cover_prod_why_islam: '/covers/cover-why-islam.jpg',
  asset_cover_prod_tenaga: '/covers/cover-faktor-tenaga.jpg',
  asset_cover_prod_unsur: '/covers/cover-faktor-unsur.jpg',
});

/**
 * Resolve catalog coverAssetRef for UI.
 * Prefer static JPEG so covers never render CDN JSON package stubs.
 */
export function resolveDemoCoverUrl(
  coverAssetRef: string | null | undefined,
): string | null {
  if (coverAssetRef === null || coverAssetRef === undefined) {
    return null;
  }
  const staticUrl = COVER_URLS[coverAssetRef];
  if (staticUrl !== undefined) return staticUrl;
  const host = resolveHostCoverUrl(coverAssetRef);
  if (host !== null && /\.(jpe?g|png|webp|gif)(\?|$)/i.test(host)) {
    return host;
  }
  return null;
}
